import { getCore } from '../../../client/core/getCore';
import type { DynamicClient } from '../../../client/types';
import { SDK_API_CORE_VERSION } from '../../../constants';
import { sessionStorageKeySchema, stateStorageKeySchema } from '../schema';

export const syncStateWithStorage = (client: DynamicClient) => {
  const core = getCore(client);

  core.state.subscribe((state) => {
    if (state.sessionExpiresAt === null) {
      void core.storage.removeItem(sessionStorageKeySchema);
    } else {
      void core.storage.setItem(sessionStorageKeySchema, {
        captchaToken: state.captchaToken,
        elevatedAccessTokens: (state.elevatedAccessTokens || []).map(
          (token) => ({
            expiresAt: token.expiresAt.getTime(),
            scopes: token.scopes,
            singleUse: token.singleUse ?? null,
            token: token.token,
          })
        ),
        legacyToken: state.legacyToken,
        mfaToken: state.mfaToken,
        sessionExpiration: state.sessionExpiresAt.getTime(),
        sessionKeys: state.sessionKeys,
        token: state.token,
      });
    }

    void core.storage.setItem(stateStorageKeySchema, {
      apiVersion: SDK_API_CORE_VERSION,
      prefetchedNonces: state.prefetchedNonces,
      prefetchedNoncesExpiration: state.prefetchedNoncesExpiration,
      projectSettings: state.projectSettings,
      unverifiedWalletAccounts: state.unverifiedWalletAccounts,
      user: state.user,
      walletProviderKeyMap: state.walletProviderKeyMap,
    });
  });
};
